module.exports = __webpack_public_path__ + "img/word4.8cc11340.webp";